
import "./assets/js/nav-pills.js";
import "./assets/scss/soft-ui-iisoul.scss";

export default {

  install() {}
};
